import { render, staticRenderFns } from "./UserInfoDrawer.vue?vue&type=template&id=1075b90c&scoped=true&"
import script from "./UserInfoDrawer.vue?vue&type=script&lang=js&"
export * from "./UserInfoDrawer.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoDrawer.vue?vue&type=style&index=0&id=1075b90c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1075b90c",
  null
  
)

export default component.exports